'use es6';

import PropTypes from 'prop-types';
import { Collection } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIButton from 'UIComponents/button/UIButton';
import { useHideDialog } from '../../../dialog/ducks';
import { EVENTS } from '../../../utils/usageTracker';
import { useUserRoleForReport } from '../../../utils/trackingUtils';
import ParentDashboardList from '../../shared/ParentDashboardList';
import SaveReportButton from '../../saveReport/SaveReportButton';
import { SAVE_UPDATES_AS_NEW } from '../../saveReport/saveNewReportTypes';
import { Set as ImmutableSet } from 'immutable';
import { getDefaultReportActionEventProperties } from '../../report-action-wrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SaveReportUpdatesConfirmModal = ({
  defaultDashboardId,
  onConfirm,
  onSaveStarted,
  onSaveSuccess,
  report,
  shouldBecomeCustom,
  usageTracker
}) => {
  const hideDialog = useHideDialog();
  const userRole = useUserRoleForReport(report);
  const handleCancel = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.cancelAssetUpdate, Object.assign({
        actionType: 'edit',
        action: 'close',
        object: shouldBecomeCustom ? 'config' : 'filters',
        role: userRole
      }, getDefaultReportActionEventProperties(report)));
    }
    hideDialog();
  };
  const UpdateExistingReportButton = /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "update-report-confirm",
    use: "primary",
    onClick: () => {
      onConfirm();
      hideDialog();
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.saveUpdates.button.text"
    })
  });
  const SaveAsNewButton = /*#__PURE__*/_jsx(SaveReportButton, {
    appUsageTracker: usageTracker,
    defaultTargetDashboardId: defaultDashboardId,
    use: "secondary",
    report: report,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.saveUpdates.modal.saveAs"
    }),
    saveUse: SAVE_UPDATES_AS_NEW,
    shouldBecomeCustom: shouldBecomeCustom,
    onButtonClick: hideDialog,
    onSaveStarted: onSaveStarted,
    onSaveSuccess: onSaveSuccess
  });
  return /*#__PURE__*/_jsxs(UIModal, {
    width: 600,
    "data-test-id": "save-report-updates-confirm-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.saveUpdates.modal.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.saveUpdates.modal.dashboardListLabel"
      }), /*#__PURE__*/_jsx(ParentDashboardList, {
        reports: ImmutableSet([report])
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.saveUpdates.modal.message"
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [UpdateExistingReportButton, SaveAsNewButton, /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: handleCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.saveUpdates.modal.cancel"
        })
      })]
    })]
  });
};
SaveReportUpdatesConfirmModal.propTypes = {
  defaultDashboardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onConfirm: PropTypes.func,
  onSaveStarted: PropTypes.func,
  onSaveSuccess: PropTypes.func,
  report: PropTypes.instanceOf(Collection).isRequired,
  shouldBecomeCustom: PropTypes.bool,
  usageTracker: PropTypes.object.isRequired
};
export default SaveReportUpdatesConfirmModal;